import React from 'react';

import { SideKickRewardsTerms } from '@components';
import { scrollTop } from '@share/utils';

import './style.scss';

interface IProps {}

class SidekickTermsPageComponent extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    scrollTop();
  }

  render(): React.ReactNode {
    return (
      <div className="sidekick-terms-page">
        <SideKickRewardsTerms />
      </div>
    );
  }
}

export const SidekickTermsPage = SidekickTermsPageComponent;
